export enum LegalDocumentType {
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
}
